/**
 * Shared auth types and utilities for the platform shell.
 *
 * The shell exposes its auth state via window.__PLATFORM_AUTH__ so that
 * federated child apps can read it without needing their own AuthProvider
 * to make separate API calls.
 */

import type { User } from "@/auth/AuthContext";

export interface PlatformAuth {
  user: User | null;
  loading: boolean;
  isAuthenticated: boolean;
  logout: () => void;
}

/**
 * Set the platform auth state on the window global.
 * Called by the shell's AuthProvider on every state change.
 */
export function setPlatformAuth(auth: PlatformAuth): void {
  window.__PLATFORM_AUTH__ = auth;
}

/**
 * Read the platform auth state from the window global.
 * Used by child apps in their RemoteEntry wrappers.
 */
export function getPlatformAuth(): PlatformAuth | undefined {
  return window.__PLATFORM_AUTH__;
}

// Augment the Window interface
declare global {
  interface Window {
    __PLATFORM_SHELL__?: boolean;
    __PLATFORM_AUTH__?: PlatformAuth;
    /** Ingestion Manager API base URL, set by canopy before loading the remote */
    __IM_API_BASE_URL__?: string;
  }
}
